import Vue from "vue";
Vue.prototype.$aaa = 1;
